import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { IEecsPackage, IEecsPackageModal } from '../types/eecs-package.types';

export interface PackageInitialState extends BaseDataReducerV2InitialState<IEecsPackage> {
  selectedPackage: IEecsPackage | null;
  currentModal: IEecsPackageModal | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducerV2<IEecsPackage, PackageInitialState>('eecs-package');

export const packageInitialState: PackageInitialState = {
  ...initialState,
  perPage: 25,
  selectedPackage: null,
  currentModal: null,
};

export const eecsPackage = createSlice({
  name: 'eecsPackage',
  initialState: packageInitialState,
  reducers: {
    setSelectedEecsPackage: (state, action: PayloadAction<IEecsPackage | null>) => {
      state.selectedPackage = action.payload;
    },
    setEecsPackageModal: (state, action: PayloadAction<IEecsPackageModal | null>) => {
      state.currentModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as PackageInitialState, action);
    });
  },
});

export const EecsPackageAC = AC;
export const onEecsPackageSort = thunks.onSort;
export const onEecsPackageFilter = thunks.onFilter;
export const clearEecsPackageFilters = AC.clearFilters;
export const setEecsPackageCurrentPage = AC.setCurrentPage;

export const { setSelectedEecsPackage, setEecsPackageModal } = eecsPackage.actions;
